import classNames from 'classnames';
import * as React from 'react';
import * as styles from './Expander.module.scss';

export type ExpanderProps = {
    title: string;
    open: boolean;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

function Expander({
    title,
    open,
    onClick,
    ...props
}: React.PropsWithChildren<ExpanderProps>) {
    return (
        <dl
            className={classNames(styles.root, {
                [styles.expanded]: open,
            })}
        >
            <dt className={styles.term}>
                <button type="button" onClick={onClick} aria-expanded={open}>
                    <span>{title}</span>

                    <svg viewBox="0 0 23.615 23.615" aria-hidden="true">
                        <g transform="translate(-1398 -5028.5)">
                            <line
                                x2="20.615"
                                transform="translate(1399.5 5040.308)"
                                fill="none"
                                strokeLinecap="round"
                                strokeWidth="3"
                            />
                            <line
                                x2="20.615"
                                transform="translate(1409.808 5030) rotate(90)"
                                fill="none"
                                strokeLinecap="round"
                                strokeWidth="3"
                                hidden={open}
                            />
                        </g>
                    </svg>
                </button>
            </dt>
            <dd className={styles.definition} hidden={!open}>
                {props.children}
            </dd>
        </dl>
    );
}

export default Expander;
